import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Routes } from "../../constants";
import { injectModels } from "../../redux/injectModels";
import { toast } from "react-toastify";
import ChangePassword from "../changePasswordFile/ChangePassword";
import EditProfile from "./EditProfile";
import { imageListClasses } from "@mui/material";
import { CircularProgress } from "@mui/material";

function Profile(props) {
  const [data, setData] = useState({});
  const [userName, setUserName] = useState();
  const [job, setJob] = useState();
  const [image, setImage] = useState("");
  const [showOverViewProfile, setShowOverViewProfile] = useState(true);
  const role = localStorage.getItem("userRole");

  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = async () => {
    props.application.setLoading(true);
    try {
      const res = await props.admin.getUserProfile();
      if (res.user) {
        setData(res && res.user);
        setUserName(res && res.user.username);
        setJob(res && res.user.job);
        setImage(res && res.user.profile_image);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };
  const handleOverView = () => {
    setShowOverViewProfile(true);
    getProfile();
  };
  return (
    <>
      <main id="main" className="main">
        <div className="pagetitle mb-3">
          <h1>Profile</h1>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to={Routes.DASHBOARD}>Home</Link>
              </li>
              <li className="breadcrumb-item active">Profile</li>
            </ol>
          </nav>
        </div>
        <section className="section profile">
          <div className="row">
            {showOverViewProfile ? (
              <div className="col-xl-4">
                <div className="card">
                  <div className="card-body profile-card pt-4 d-flex flex-column align-items-center">
                    {image ? (
                      <img
                        src={image}
                        alt="Profile"
                        className="rounded-circle"
                      />
                    ) : (
                      <CircularProgress />
                    )}
                    <h2>{userName}</h2>
                    <h3>{job}</h3>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            <div className="col-xl-8">
              <div className="card">
                <div className="card-body pt-3">
                  <ul className="nav nav-tabs nav-tabs-bordered">
                    <li className="nav-item">
                      <button
                        className="nav-link active"
                        data-bs-toggle="tab"
                        data-bs-target="#profile-overview"
                        onClick={handleOverView}
                      >
                        Overview
                      </button>
                    </li>

                    {role === "admin" && (
                      <li className="nav-item">
                        <button
                          className="nav-link"
                          data-bs-toggle="tab"
                          data-bs-target="#profile-edit"
                          onClick={() => {
                            setShowOverViewProfile(false);
                          }}
                        >
                          Edit Profile
                        </button>
                      </li>
                    )}

                    <li className="nav-item">
                      <button
                        className="nav-link"
                        data-bs-toggle="tab"
                        data-bs-target="#profile-change-password"
                        onClick={() => {
                          setShowOverViewProfile(false);
                        }}
                      >
                        Change Password
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content pt-2">
                    <div
                      className="tab-pane fade show active profile-overview"
                      id="profile-overview"
                    >
                      <h5 className="card-title">About</h5>
                      <p className="fst-italic">{data.about}</p>

                      <h5 className="card-title">Profile Details</h5>

                      <div className="row">
                        <div className="col-lg-3 col-md-4 label ">
                          Full Name
                        </div>
                        <div className="col-lg-9 col-md-8">{data.username}</div>
                      </div>
                      <div className="row">
                        <div className="col-lg-3 col-md-4 label">Job</div>
                        <div className="col-lg-9 col-md-8">{data.job}</div>
                      </div>

                      <div className="row">
                        <div className="col-lg-3 col-md-4 label">Country</div>
                        <div className="col-lg-9 col-md-8">{data.country}</div>
                      </div>

                      <div className="row">
                        <div className="col-lg-3 col-md-4 label">Address</div>
                        <div className="col-lg-9 col-md-8">{data.address}</div>
                      </div>

                      <div className="row">
                        <div className="col-lg-3 col-md-4 label">Phone</div>
                        <div className="col-lg-9 col-md-8">
                          {data.phone_number}
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-3 col-md-4 label">Email</div>
                        <div className="col-lg-9 col-md-8">{data.email}</div>
                      </div>
                    </div>
                    <EditProfile />
                    <ChangePassword />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
export default injectModels(["admin", "application"])(Profile);
